function getViewPortWidth() {
  vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
  return vw;
}

function getViewPortHeight() {
  vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
  return vh;
}

function getViewPortDimension() {

  vw = getViewPortWidth();

  let dimensions = [{
    mobile_375: false,
    mobile_700: false,
    tablet_701: false,
    tablet_1199: false,
    skyscraper_1200: false,
    fireplace_1320: false,
    sitebar_1460: false,
  }];

  if ( vw >= 375 ) {
    dimensions.mobile_375 = true;
  } else {
    dimensions.mobile_375 = false;
  }

  if ( vw <= 700 ) {
    dimensions.mobile_700 = true;
  } else {
    dimensions.mobile_700 = false;
  }

  if ( vw >= 701 ) {
    dimensions.tablet_701 = true;
  } else {
    dimensions.tablet_701 = false;
  }

  if ( vw <= 1199 ) {
    dimensions.tablet_1199 = true;
  } else {
    dimensions.tablet_1199 = false;
  }

  if ( vw >= 1200 ) {
    dimensions.skyscraper_1200 = true;
  } else {
    dimensions.skyscraper_1200 = false;
  }

  if ( vw >= 1320 ) {
    dimensions.fireplace_1320 = true;
  } else {
    dimensions.fireplace_1320 = false;
  }

  if ( vw >= 1460 ) {
    dimensions.sitebar_1460 = true;
  } else {
    dimensions.sitebar_1460 = false;
  }

  return dimensions;
}

let vw = getViewPortWidth();
let vh = getViewPortHeight();
let dimensions = getViewPortDimension();

export {getViewPortWidth, getViewPortHeight, getViewPortDimension, vw, vh, dimensions };
